var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"popover-menu-container bg-white text-[14px] rounded-[8px] overflow-hidden font-sans py-1 px-[2px]"},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }